"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SkeletonLine", {
    enumerable: true,
    get: function() {
        return SkeletonLine;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const SkeletonLine = (param)=>{
    let { width = "100%", height = "0.8rem", className = "", dark = false, block = false, borderRadius } = param;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: {
            width,
            height,
            borderRadius
        },
        className: _style.default.dynamic([
            [
                "972beedf55a0226d",
                [
                    block ? "block" : "inline-block"
                ]
            ]
        ]) + " " + "".concat(dark ? "dark" : "", " ").concat(className)
    }), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "972beedf55a0226d",
        dynamic: [
            block ? "block" : "inline-block"
        ]
    }, "span.__jsx-style-dynamic-selector{display:".concat(block ? "block" : "inline-block", ";background:-webkit-linear-gradient(left,#f5f5f5 0%,#efefef 15%,#f5f5f5 30%);background:-moz-linear-gradient(left,#f5f5f5 0%,#efefef 15%,#f5f5f5 30%);background:-o-linear-gradient(left,#f5f5f5 0%,#efefef 15%,#f5f5f5 30%);background:linear-gradient(to right,#f5f5f5 0%,#efefef 15%,#f5f5f5 30%);-webkit-animation:skeletonAnimation 3s linear infinite;-moz-animation:skeletonAnimation 3s linear infinite;-o-animation:skeletonAnimation 3s linear infinite;animation:skeletonAnimation 3s linear infinite;-webkit-background-size:1200px 100%;-moz-background-size:1200px 100%;-o-background-size:1200px 100%;background-size:1200px 100%;max-width:100%}span.dark.__jsx-style-dynamic-selector{background-image:-webkit-linear-gradient(left,#d0d0d0 0%,#c1c0c0 15%,#d0d0d0 30%);background-image:-moz-linear-gradient(left,#d0d0d0 0%,#c1c0c0 15%,#d0d0d0 30%);background-image:-o-linear-gradient(left,#d0d0d0 0%,#c1c0c0 15%,#d0d0d0 30%);background-image:linear-gradient(to right,#d0d0d0 0%,#c1c0c0 15%,#d0d0d0 30%)}@-webkit-keyframes skeletonAnimation{0%{background-position:-1200px 0%}100%{background-position:1200px 0%}}@-moz-keyframes skeletonAnimation{0%{background-position:-1200px 0%}100%{background-position:1200px 0%}}@-o-keyframes skeletonAnimation{0%{background-position:-1200px 0%}100%{background-position:1200px 0%}}@keyframes skeletonAnimation{0%{background-position:-1200px 0%}100%{background-position:1200px 0%}}")));
};

//# sourceMappingURL=SkeletonLine.js.map